import { Checkbox, Stack, styled } from "@mui/material";
import React, { FC, useCallback } from "react";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import CheckboxBg from "../../Misc/CheckboxBg";

export type AssetCardHeaderProps = {
  obj: DbAssetObjectInfos;
  selected?: boolean;
  onSelectClick?: (obj: DbAssetObjectInfos) => void;
};

const AssetCardHeader = React.forwardRef<any, AssetCardHeaderProps>((props, ref) => {
  const { onSelectClick, obj, selected = false } = props;

  const handleCheckboxClick: React.MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      e.stopPropagation();

      if (!onSelectClick) return;

      onSelectClick(obj);
    },
    [onSelectClick, obj]
  );

  return (
    <CardTop ref={ref}>
      <CardTopLeft sx={{ zIndex: 1200 }} direction="row" alignItems="center">
        <CheckboxBg checked={selected || false} className="MuiCheckbox-Bg" sx={{ top: "1px", left: "9px" }} />
        <Checkbox checked={selected || false} onClick={handleCheckboxClick}></Checkbox>
      </CardTopLeft>
    </CardTop>
  );
});

export default AssetCardHeader;

const CardTop = styled("div")(({ theme }) => ({
  position: "absolute",
  right: 0,
  top: theme.spacing(2),
  left: theme.spacing(1),
  zIndex: 3,
  display: "flex",
  justifyContent: "space-between",
  ".MuiChip-label": {
    opacity: 0.8,
  },

  ".MuiIconButton-root, .MuiCheckbox-root": {
    position: "relative",
    top: theme.spacing(-1),
  },
}));

const CardTopLeft = styled(Stack)(() => ({
  position: "relative",
}));
